export default __webpack_public_path__ + "static/media/dark_mode.5eba3eec.svg";